<app-section [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [title]="title"
             [key]="key"
             [containerClass]="false">

    <ng-template #section>

        <div class="next-offers-section"
            [ngClass]="{
                'next-offers-section--list': offersSectionStateService.isListView,
                'next-offers-section--table': offersSectionStateService.isTableView,
                'next-offers-section--filters-collapsed': !filtersService.filtersExpanded,
                'next-offers-section--header-title-badge': headerWithTitleBadge,
                'next-offers-section--offers-comparison-panel-visible': offersSectionStateService.offersComparisonPanelVisible
            }">

            <app-offers-comparison-panel *ngIf="offersSectionStateService.offersComparisonPanelVisible"
                                         [offers]="offersSectionStateService.comparisonOffers"
                                         (removeOffer)="offersSectionStateService.removeOfferFromComparison($event)"
                                         (compare)="offersSectionStateService.showOffersComparison()"
                                         (clear)="offersSectionStateService.clearOffersComparison()"
                                         class="next-offers-section__comparison-panel"
            ></app-offers-comparison-panel>

            <div *ngIf="controlPanelVisible"
                 class="next-offers-section__control-panel">
                <app-offers-control-panel [offersAmount]="offersNumber"
                                          (viewChange)="offersSectionStateService.changeView($event)"></app-offers-control-panel>
            </div>

            <div class="next-offers-section__content next-offers-section__content--list">
                <div *ngIf="leftContentVisible"
                     class="next-offers-section__left"
                     [ngClass]="{'next-offers-section__left--hidden': !filtersService.filtersExpanded}"
                >
                    <div class="next-offers-section__left__content">
                        <div class="next-offers-section__data-summary">
                            <app-insurance-data-summary></app-insurance-data-summary>
                        </div>

                        <div *ngIf="filtersVisible"
                             class="next-offers-section__filters">
                            <app-offers-filters></app-offers-filters>
                        </div>
                    </div>
                </div>

                <div class="next-offers-section__right">

                    <div *ngIf="offerRecommendationsService.recommendationsActive"
                         class="next-offers-section__recommendations">
                        <div class="next-offers-section__recommendations__title">
                            {{ 'NEXT_OFFERS_SECTION.recommendationsTitle' | translate }}
                        </div>

                        <div class="next-offers-section__recommendations__offers">
                            <app-offers-list [offers]="recommendedOffers"></app-offers-list>
                        </div>
                    </div>

                    <div class="next-offers-section__offers">

                        <div *ngIf="offersNumber > 0"
                             class="next-offers-section__offers__title next-offers-section__offers__title--other-offers">
                            {{ 'NEXT_OFFERS_SECTION.otherOffers' | translate }}
                            <span class="next-offers-section__offers-number">
              {{ offersNumber }} {{ offersNumber | amountNounTranslation:translationsContainer:true | async }}
            </span>
                        </div>

                        <div class="next-offers-section__offers__title next-offers-section__offers__title--all-offers">
                            {{ 'NEXT_OFFERS_SECTION.allOffers' | translate }}
                        </div>

                        <div class="next-offers-section__offers__list--full">
                            <app-offers-list [offers]="offers"></app-offers-list>
                        </div>

                        <div class="next-offers-section__offers__list--expandable">
                            <app-offers-list [offers]="offersForExpandableMode"></app-offers-list>

                            <div *ngIf="hiddenOffersExist"
                                 class="next-offers-section__offers__more-offers-btn">
                                <button class="btn btn--secondary btn--small-padding"
                                        (click)="showHiddenOffers()">
                                    {{ 'NEXT_OFFERS_SECTION.showOtherOffers' | translate }}
                                    {{ hiddenOffersAmount }} {{ hiddenOffersAmount | amountNounTranslation:translationsContainer:true | async }}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="noOffersForFilters"
                         class="next-offers-section__no-filtered-offers">
                        <app-no-offers-tile></app-no-offers-tile>
                    </div>
                </div>
            </div>

            <div *ngIf="tableViewAllowed"
                 class="next-offers-section__content next-offers-section__content--table">
                <app-offers-table class="next-offers-section__content__table"
                                  [offers]="offersSectionStateService.rawOffers"></app-offers-table>
            </div>
        </div>

    </ng-template>
</app-section>
